// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kwEs","requiredAsterisk":"Info_requiredAsterisk__3CKGD"};